var _path, _path2, _path3, _path4, _line, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDoorArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 36,
    viewBox: "0 0 49 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 11V6C35 4.89543 34.1046 4 33 4H12C10.8954 4 10 4.89543 10 6V30C10 31.1046 10.8954 32 12 32H33C34.1046 32 35 31.1046 35 30V25",
    stroke: "#545454",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 16.6727C31.3082 16.6727 30.95 17.0308 30.95 17.4727C30.95 17.9145 31.3082 18.2727 31.75 18.2727V16.6727ZM48.0045 18.0383C48.317 17.7259 48.317 17.2194 48.0045 16.907L42.9134 11.8158C42.601 11.5034 42.0944 11.5034 41.782 11.8158C41.4696 12.1282 41.4696 12.6348 41.782 12.9472L46.3075 17.4727L41.782 21.9981C41.4696 22.3106 41.4696 22.8171 41.782 23.1295C42.0944 23.4419 42.601 23.4419 42.9134 23.1295L48.0045 18.0383ZM31.75 18.2727H47.4389V16.6727H31.75V18.2727Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35L1 35",
    stroke: "#545454",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2 11.1081C37.2 11.5499 37.5582 11.9081 38 11.9081C38.4418 11.9081 38.8 11.5499 38.8 11.1081H37.2ZM38.8 24.8919C38.8 24.4501 38.4418 24.0919 38 24.0919C37.5582 24.0919 37.2 24.4501 37.2 24.8919H38.8ZM10 1.8H35V0.2H10V1.8ZM7.8 35V4H6.2V35H7.8ZM37.2 4V11.1081H38.8V4H37.2ZM37.2 24.8919V35H38.8V24.8919H37.2ZM35 1.8C36.215 1.8 37.2 2.78497 37.2 4H38.8C38.8 1.90132 37.0987 0.2 35 0.2V1.8ZM10 0.2C7.90132 0.2 6.2 1.90132 6.2 4H7.8C7.8 2.78497 8.78497 1.8 10 1.8V0.2Z",
    fill: "#545454"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.8,
    y1: 4,
    x2: 22.8,
    y2: 32,
    stroke: "#545454",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5H16",
    stroke: "#545454",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorArrow);
export default __webpack_public_path__ + "static/media/iconDoorArrow.fae4f8d0f052896ec7d5164019d815e7.svg";
export { ForwardRef as ReactComponent };